/**
 * Panels height calculator for Shopify theme
 * Sums the height of announcement bar, sticky header, and shop-by-category heading,
 * then updates the CSS variable --panelsHeight on :root.
 * First match per selector only; uses offsetHeight like header.liquid. Safe for dynamic section loading.
 */
(function () {
  'use strict';

  // Use element+class (slideshow-component and sticky-header are tag names, not classes).
  const SELECTORS = [
    'slideshow-component.announcement-bar',
    'sticky-header.header-wrapper',
    '.flexible-tile__header'
  ];

  /**
   * Returns the total height of the first matching element per selector (no double-counting).
   * Uses offsetHeight to match header.liquid --header-height behavior for correct layout height.
   * @returns {number} Total height in pixels.
   */
  function getPanelsHeight() {
    let total = 0;
    const root = document.documentElement;

    SELECTORS.forEach(function (selector) {
      const el = root.querySelector(selector);
      if (el && typeof el.offsetHeight === 'number') {
        total += el.offsetHeight;
      }
    });

    return total;
  }

  /**
   * Updates the --panelsHeight CSS variable on :root (same pattern as --header-height in header.liquid).
   */
  function updatePanelsHeight() {
    const height = getPanelsHeight();
    document.documentElement.style.setProperty('--panelsHeight', height + 'px');
  }

  function runWhenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runWhenReady);
      return;
    }
    // Run after layout so offsetHeight is accurate (header runs in connectedCallback).
    requestAnimationFrame(function () {
      updatePanelsHeight();
    });
  }

  function init() {
    runWhenReady();
    window.addEventListener('resize', updatePanelsHeight);
    document.addEventListener('shopify:section:load', updatePanelsHeight);
    document.addEventListener('shopify:section:reorder', updatePanelsHeight);
  }

  init();

  window.updatePanelsHeight = updatePanelsHeight;
})();
